import {ActionConfirm} from './../../../../../back-office/Models/ActionConfirm';
import {ActionType} from './../../../../../back-office/Models/ActionType';
import {Component, OnInit, OnDestroy, OnChanges, Input} from '@angular/core';
import {ServiceRequestService} from './../../../../../dealer-system/Services/service-request.service';
import {ServiceRequest} from './../../../../../back-office/Models/ServiceRequest';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-dealer-reply-step',
  templateUrl: './dealer-reply-step.component.html',
  styleUrls: ['./dealer-reply-step.component.scss']
})
export class DealerReplyStepComponent implements OnInit, OnDestroy, OnChanges {

  @Input() Index;

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];
  public cardIsActive = false;
  public solutionSteps = [];

  constructor(
    private requestService: ServiceRequestService,
  ) {
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnChanges() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
    this.load();
  }

  private load() {
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        this.cardIsActive = this.checkCardActivation(this.Index);
        const steps = [];
        for (const replyItem of this.request.reply.replyItems) {
          steps.push(replyItem.solutionStep);
        }
        this.solutionSteps = steps.filter((item) => !item.restricted);
      })
    );
  }

  private checkCardActivation(index) {
    if (index === 0) {
      return true;
    }
    if (this.request.reply.replyItems[index] && this.request.reply.replyItems[index].skipped) {
      return false;
    }
    if (this.request.reply.replyItems[index - 1]) {
      if (this.request.reply.replyItems[index - 1].skipped) {
        return true;
      } else {
        return this.request.reply.replyItems[index - 1].isDone;
      }
    }
  }

  public checkIsDone() {

    if ([ActionType.REORDER, ActionType.PACKAGING_LABEL, ActionType.INVOICE].includes(this.solutionSteps[this.Index].actionType.name)) {
      return this.request.reply.replyItems[this.Index] && this.request.reply.replyItems[this.Index].isDone;
    }
    return true;
  }

  public onlyBackoffice() {
    if (this.solutionSteps[this.Index].actionType.name === ActionType.CONFIRMATION &&
      this.solutionSteps[this.Index].actionConfirm.type === ActionConfirm.BACKOFFICE_TYPE) {
      return true;
    }
    return false;
  }

  public ableToSee() {
    return this.solutionSteps[this.Index] &&
    this.solutionSteps[this.Index].actionType.name !== 'email' &&
    this.solutionSteps[this.Index].actionType.name !== 'change_status' &&
    this.cardIsActive &&
    this.checkIsDone() &&
    !this.onlyBackoffice();
  }
}
